module.exports = __webpack_public_path__ + "img/metaMaskInstallationStep_13_mobile.35ab91d.png";